import { ButtonHTMLAttributes, FC } from 'react';
import classNames from 'clsx';
import s from './button.module.scss';

export interface AppButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  variant?:
    | 'primary'
    | 'white'
    | 'text'
    | 'icon'
    | 'outlined'
    | 'outlined-white';
  size?: 'large' | 'middle' | 'small';
}

const variantStyles = {
  primary: s.primary,
  white: s.white,
  outlined: s.outlined,
  icon: s.icon,
  text: s.text,
  'outlined-white': s.outlinedWhite,
};

const sizeStyles = {
  large: s.large,
  middle: s.middle,
  small: s.small,
};

export const Button: FC<AppButtonProps> = (props) => {
  const {
    children,
    size = 'middle',
    variant = 'primary',
    className,
    type = 'button',
    ...rest
  } = props;

  return (
    <button
      className={classNames(
        s.btn,
        className,
        variantStyles[variant],
        sizeStyles[size]
      )}
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
};
